import { render } from "./AvailablePrograms.vue?vue&type=template&id=70cbd83c"
import script from "./AvailablePrograms.vue?vue&type=script&lang=js"
export * from "./AvailablePrograms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__